import { Loop } from '@material-ui/icons';
import React from 'react';

interface SpinnerProps {
  className?: string;
  /**
   * Element used for the wrapper. Defaults to a div; inline callers (a figure
   * inside a <p> or <b>) pass 'span' so the markup stays valid.
   */
  as?: 'div' | 'span';
}
const Spinner: React.FC<SpinnerProps> = ({
  className,
  as: Wrapper = 'div'
}) => (
  <Wrapper data-testid="LoopIcon" className={className}>
    <Loop className="h-full w-full inline animate-spin" />
  </Wrapper>
);

export default Spinner;
